var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.lineParts),function(line,ind){return _c('span',{key:ind,class:line.cssClass},[_vm._v(" "+_vm._s(line.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }